module.exports = __webpack_public_path__ + "static/media/mainLogo.b18872e8.png";